/** Localised browser validation message for the required privacy checkboxes. */
(function () {
  function sync(field) {
    field.setCustomValidity(field.checked ? '' : field.dataset.consentMessage || '');
  }

  document.querySelectorAll('[data-consent-message]').forEach(sync);

  if (window.consentValidationReady) return;
  window.consentValidationReady = true;

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field.dataset && 'consentMessage' in field.dataset) sync(field);
  });
})();
